/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Manage_SubscriptionInputs */

const en_plan_manage_subscription = /** @type {(inputs: Plan_Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Subscription`)
};

const es_plan_manage_subscription = /** @type {(inputs: Plan_Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar suscripción`)
};

/**
* | output |
* | --- |
* | "Manage Subscription" |
*
* @param {Plan_Manage_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_manage_subscription = /** @type {((inputs?: Plan_Manage_SubscriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Manage_SubscriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_manage_subscription(inputs)
	return en_plan_manage_subscription(inputs)
});